var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "1280px",
      "width": "100%"
    }
  }, [_c('v-row', {
    staticClass: "mt-8",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pt-0 pb-0 headline text-start",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("게시글 목록")]), _c('v-spacer'), _c('v-col', {
    staticClass: "pt-0 pb-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "ma-2",
    attrs: {
      "color": "secondary",
      "rounded": ""
    },
    on: {
      "click": function click($event) {
        _vm.showSearch = !_vm.showSearch;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-filter-variant")]), _vm._v("검색필터")], 1)], 1)], 1), _c('v-expand-transition', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showSearch,
      expression: "showSearch"
    }],
    staticClass: "elevation-1 mx-auto"
  }, [_c('v-card-title', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("검색필터")]), _c('v-card-text', [_c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-date-field', {
    attrs: {
      "label": "작성일자",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.createdAt[0],
      callback: function callback($$v) {
        _vm.$set(_vm.filter.createdAt, 0, $$v);
      },
      expression: "filter.createdAt[0]"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-date-field', {
    attrs: {
      "label": "작성일자",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.filter.createdAt[1],
      callback: function callback($$v) {
        _vm.$set(_vm.filter.createdAt, 1, $$v);
      },
      expression: "filter.createdAt[1]"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "mt-3"
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.searchKeys,
      "label": "검색조건",
      "hide-details": "",
      "persistent-placeholder": ""
    },
    model: {
      value: _vm.filter.searchKey,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchKey", $$v);
      },
      expression: "filter.searchKey"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "검색어",
      "persistent-placeholder": "",
      "hide-details": "",
      "disabled": !_vm.filter.searchKey
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "rounded": "",
      "text": ""
    },
    on: {
      "click": function click($event) {
        (_vm.page = 1) && _vm.search();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mt-1 mr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-magnify")]), _vm._v("검색")], 1)], 1)], 1)], 1), _vm.$route.query.code == 'youtube' ? [_c('v-row', {
    staticClass: "mb-n4"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('youtube-categories-list')], 1)], 1)] : _vm._e(), _vm.$route.query.code == 'report' ? [_c('v-row', {
    staticClass: "mb-n4"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('report-list-categories')], 1)], 1)] : _vm._e(), _vm.$route.query.code == 'forms' ? [_c('v-row', {
    staticClass: "mb-n4"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('forms-list-categories')], 1)], 1)] : _vm._e(), _c('v-data-table', {
    staticClass: "elevation-1 mt-4",
    attrs: {
      "items": _vm.boards,
      "headers": _vm.boardsHeaders.filter(function (header) {
        return header.test ? header.test(_vm.$route.query.code) : true;
      }),
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.no",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s((_vm.page - 1) * _vm.limit + (+_vm.boards.indexOf(item) + 1)) + " ")];
      }
    }, {
      key: "item.thumb",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-row', [item.thumb ? _c('v-img', {
          attrs: {
            "src": item.thumb,
            "width": "54",
            "height": "54",
            "contain": ""
          }
        }) : _vm._e()], 1)];
      }
    }, {
      key: "item.meta.href",
      fn: function fn(_ref3) {
        var value = _ref3.value;
        return [!!value ? _c('v-btn', {
          attrs: {
            "icon": "",
            "text": "",
            "href": value,
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-link")])], 1) : [_vm._v("-")]];
      }
    }, {
      key: "item.meta.youtube",
      fn: function fn(_ref4) {
        var value = _ref4.value;
        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "text": "",
            "href": value,
            "target": "_blank"
          }
        }, [_c('v-icon', [_vm._v("mdi-link")])], 1)];
      }
    }, {
      key: "item.category",
      fn: function fn(_ref5) {
        var _vm$categories$value;

        var value = _ref5.value;
        return [_vm._v(" " + _vm._s(((_vm$categories$value = _vm.categories[value]) === null || _vm$categories$value === void 0 ? void 0 : _vm$categories$value.text) || value) + " ")];
      }
    }, {
      key: "item.createdAt",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [_vm._v(" " + _vm._s(item.createdAt.toDateTime()) + " ")];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref7) {
        var item = _ref7.item;
        return [_c('v-icon', {
          attrs: {
            "small": "",
            "title": "수정"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v("mdi-pencil")]), false ? _c('v-icon', {
          staticClass: "ml-2",
          attrs: {
            "small": "",
            "title": "복사"
          },
          on: {
            "click": function click($event) {
              return _vm.copy(item);
            }
          }
        }, [_vm._v("mdi-content-copy")]) : _vm._e(), _c('v-icon', {
          staticClass: "ml-2",
          attrs: {
            "small": "",
            "title": "삭제"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v("mdi-delete")])];
      }
    }], null, true)
  }), _c('v-pagination', {
    staticClass: "mt-4 mb-12",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }), _c('v-btn', {
    attrs: {
      "bottom": "",
      "color": "accent",
      "fab": "",
      "fixed": "",
      "right": ""
    },
    on: {
      "click": function click($event) {
        return _vm.create();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1)], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }